// extracted by mini-css-extract-plugin
export var downArrow = "_b0-0";
export var label = "_b0-1";
export var treatmentCard = "_b0-3";
export var upArrow = "_b0-2";